import { Controller } from "@hotwired/stimulus"

// eslint-disable-next-line import/no-default-export
export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    this.boundCloseFromOther = this.closeFromOther.bind(this)
    document.addEventListener("dropdown:close-others", this.boundCloseFromOther)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("dropdown:close-others", this.boundCloseFromOther)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    document.dispatchEvent(new CustomEvent("dropdown:close-others", { detail: { sender: this.element } }))
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this.boundClickOutside)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundClickOutside)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeFromOther(event) {
    if (event.detail?.sender && event.detail.sender !== this.element) {
      this.close()
    }
  }
}
